<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="dataForm" class="form-container">
	<div class="flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
		<span>{{ title }}</span>
		<button mat-icon-button (click)="addRow()" color="primary">
			<mat-icon>add</mat-icon>
		</button>
	</div>

	<div formArrayName="itemArray" *ngIf="listHasItems">
		<div id="ticket-price-type-form-add-list" cdkDropList [cdkDropListData]="itemArray.controls" (cdkDropListDropped)="onListDrop($event)" [cdkDropListDisabled]="!allowReorder">
			<div *ngFor="let item of itemArray.controls; let i = index" cdkDrag [cdkDragData]="item" [cdkDragDisabled]="!allowReorder">
				<div [formGroup]="item" class="allowed-ticket-row flex-layout-row flex-layout-align-start-center flex-layout-gap-10px">
					<div *ngIf="allowReorder">
						<mat-icon class="drag-handle" cdkDragHandle title="Reorder">reorder</mat-icon>
					</div>
					<mat-form-field>
						<mat-label>Ticket Price Type</mat-label>
						<mat-select formControlName="ticketPriceTypeId" name="type" panelClass="full-width-panel">
							<mat-option *ngFor="let lookup of lookupData" [value]="lookup.id">
								{{ lookup.text }}
							</mat-option>
						</mat-select>
						<mat-error *ngIf="ticketPriceTypeId(i).touched && ticketPriceTypeId(i).errors?.required"> Ticket Price Type is required </mat-error>
					</mat-form-field>
					<div class="pseudo-form-field">
						<button mat-icon-button (click)="removeRow(i)">
							<mat-icon class="delete-button">delete</mat-icon>
						</button>
					</div>
				</div>
			</div>
		</div>
		<br />
	</div>
	<div *ngIf="!listHasItems" class="table-no-items">No items</div>
</div>
